module.exports = __webpack_public_path__ + "static/media/main idea.59d1ffaf.mp3";